import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
const defaultLabel = (isSmall: boolean) => ({
  padding: ['4px 8px', '4px 8px', '4px 8px', '4px 8px 2px'],
  textTransform: 'uppercase',
  letterSpacing: '0.6px',
  fontFamily: theme.fonts.uniformMedium,
  fontSize: isSmall ? theme.fontSizes.omnibus : [theme.fontSizes.omnibus, theme.fontSizes.omnibus, theme.fontSizes.caption],
  lineHeight: '140%',
  fontWeight: 500,
  bg: theme.rawColors.accent700,
  color: theme.rawColors.neutralWhite
});
export default {
  customizeButton: (isSmall = false) => ({
    position: 'absolute',
    zIndex: theme.zIndex.documentHigh,
    maxHeight: '40px',
    top: isSmall ? '8px' : ['8px', '8px', '8px', '16px'],
    left: isSmall ? '8px' : ['8px', '8px', '8px', '16px']
  }),
  bottomLabels: {
    position: 'absolute',
    left: '8px',
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px'
  },
  rightLabels: (isSmall = false) => ({
    position: 'absolute',
    top: isSmall ? '8px' : ['8px', '8px', '8px', '16px'],
    right: isSmall ? '8px' : ['8px', '8px', '8px', '16px'],
    transform: 'translateY(-100%) rotate(-90deg)',
    transformOrigin: 'bottom right',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: '8px',
    backfaceVisibility: 'hidden',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    zIndex: theme.zIndex.documentHigh
  }),
  percentLabel: (transparent: boolean) => ({
    ...defaultLabel(false),
    bg: transparent ? 'transparent' : theme.rawColors.neutralWhite,
    fontFamily: theme.fonts.uniformExtra,
    letterSpacing: '0.9px',
    fontSize: theme.fontSizes.bigText,
    color: theme.rawColors.darkGrey700,
    fontWeight: theme.fontWeights.normal,
    transform: 'translateY(0)',
    ...reusables.mainTransition('transform')
  }),
  whiteLabel: (transparent: boolean, isSmall) => ({
    ...defaultLabel(isSmall),
    color: theme.rawColors.darkGrey700,
    bg: transparent ? 'transparent' : theme.rawColors.neutralWhite,
    fontWeight: 500,
    transform: 'translateY(0)',
    ...reusables.mainTransition('transform')
  }),
  redLabel: (isSmall: boolean) => ({
    ...defaultLabel(isSmall),
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility'
  }),
  blackLabel: (isSmall: boolean) => ({
    ...defaultLabel(isSmall),
    bg: theme.rawColors.darkGrey700,
    color: theme.rawColors.neutralWhite,
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    textRendering: 'optimizeLegibility'
  })
};